import React, { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchCollection, queryKeys } from "@/src/services/reactQuery/reactQueryService";
import _head from "lodash/head";
import { apiPost } from "@/src/services/apiClient";

interface CheckoutOrderProviderValue {
  checkoutOrder: any;
  isLoading: boolean;
  isError: boolean;
  create: Function;
  isInitialized: boolean;
}

const checkoutOrderContextDefaults: CheckoutOrderProviderValue = {
  checkoutOrder: null,
  isLoading: false,
  isError: false,
  create: () => {},
  isInitialized: false,
};
const CheckoutOrderContext = React.createContext(checkoutOrderContextDefaults);

function CheckoutOrderProvider({ children, orderId }: { children: React.ReactElement, orderId: string | null }) {
  const {
    data: checkoutOrderCollection,
    isLoading,
    isError,
  } = useQuery({
    queryKey: queryKeys.collection("/checkout_orders", {orderIdentifier: orderId}),
    queryFn: () => fetchCollection("/checkout_orders", {orderIdentifier: orderId})
  });
  const checkoutOrder: any = _head(checkoutOrderCollection);

  const create = async (data: any) => {
    await apiPost("/checkout_orders", data);
  }

  const data: CheckoutOrderProviderValue = {
    checkoutOrder,
    isLoading,
    isError,
    create,
    isInitialized: true,
  };

  return <CheckoutOrderContext.Provider value={data}>{children}</CheckoutOrderContext.Provider>;
}

const useCheckoutOrder = (): CheckoutOrderProviderValue => {
  const checkoutOrderContext = useContext(CheckoutOrderContext);
  if (!checkoutOrderContext.isInitialized) {
    throw new Error("useCheckoutOrder can only be used inside CheckoutOrderProvider");
  }
  return checkoutOrderContext;
};

export { CheckoutOrderProvider, useCheckoutOrder };
